import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { StudentLableConstant } from 'src/app/constants/label-constants';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-student-view',
  templateUrl: './student-view.component.html',
  styleUrls: ['./student-view.component.scss']
})
export class StudentViewComponent {
  StudentDetailForm: FormGroup = this.formBuilder.group({});
  studentId: number = 0;
  StudetList: any = [];
  companyConstant: any = [];
  StudentConstant: any = [];
  cancel: string = CommonConstant.CANCEL;
  CommonConstant: any = [];
  flag: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    public modalService: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.CommonConstant = CommonConstant;
    this.StudentConstant = StudentLableConstant;
    this.getStudentSetDetail(this.studentId);
  }

  get StudentDetailFormControl() {
    return this.StudentDetailForm.controls;
  }

  getStudentSetDetail(StudentID: number) {
    const apiUrl = this.apiUrl.apiUrl.student.GetStudentById.replace("{id}", StudentID.toString());
    this.commonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.StudetList = data.data;
        this.spinner.hide();
        this.flag = true;
      },
      error: (err) => {
        console.log('GetStudentById-Error', err);
      }
    });
  }
}